import axios from 'axios';
import { API_URL } from '../../../../lib/const';


export const deleteInvite = (invite) => (
  axios.delete(`${API_URL}/invites/${invite}`)
    .then(response => response.data)
);

export const deleteBulkInvite = (id) => (
  axios.delete(`${API_URL}/invite-processes/${id}/bulk_delete_invites`)
    .then(response => response.data)
);
